import React, { Component } from "react"

export default class styleInfo extends Component {
  render() {
    const { styleInfo, styleImage, onChange } = this.props
    return (
      <div class="col-md-12 nopadding">
        <div class="col-md-2 step-one nopadding">
          <div class="form-group">
            <label for="img ml-1">IMAGE</label>
            <div class="col-md-12 no-padding ib-fields">
              <div class="col-md-12 ib-right no-padding">
                <div class="upload-photo">
                  <img src={styleImage} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 view-ib-left nopadding">
          <div class="card-light ib-list-view">
            <ul class="main-list">
              <li>
                <ul>
                  <li>
                    Created Date<span>:</span>{" "}
                  </li>
                  <li>{styleInfo.createdAt}</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Style No <span>:</span>{" "}
                  </li>
                  <li>{styleInfo.styleNumber}</li>
                </ul>
                <ul>
                  <li>
                    Ref <span>:</span>{" "}
                  </li>
                  {/* {styleInfo.reference.referenceCode.slice(styleInfo.reference.referenceCode.indexOf('-'))} */}
                  {/* <li>{styleInfo.reference.referenceCode.slice(styleInfo.reference.referenceCode.indexOf('-'))}</li> */}
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Customer Dept<span>:</span>{" "}
                  </li>
                  <li>
                    {styleInfo.customer.customerName +
                      " " +
                      styleInfo.customer.departments.departmentName}
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Reference Color <span>:</span>{" "}
                  </li>
                  <li>{styleInfo.reference.referenceColor}</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Magnum Style Name <span>:</span>{" "}
                  </li>
                  <li>{styleInfo.reference.magnumStyleName}</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Customer Ref No<span>:</span>{" "}
                  </li>
                  <li>{styleInfo.reference.customerRefNumber}</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Buyer Style Name<span>:</span>{" "}
                  </li>
                  <li>{styleInfo.reference.buyerStyleName}</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Fabric Type<span>:</span>{" "}
                  </li>
                  <li>{styleInfo.reference.fabricType}</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-5 view-ib-right nopadding">
          <div class="card-light ib-list-view">
            <ul class="main-list">
              <li>
                <ul>
                  <li>
                    Season <span>:</span>{" "}
                  </li>
                  {/* <li> {styleInfo.reference.season} </li> */}
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Story Name<span>:</span>{" "}
                  </li>
                  {/* <li>{styleInfo.reference.buyerStyleName}</li> */}
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Buyer Name<span>:</span>{" "}
                  </li>
                  {/* <li> {styleInfo.reference.buyerStyleName} </li> */}
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Assistant Buyer<span>:</span>{" "}
                  </li>
                  {/* <li> {styleInfo.reference.buyerStyleName} </li> */}
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Fabric technologist<span>:</span>{" "}
                  </li>
                  {/* <li> {styleInfo.reference.fabricType} </li> */}
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    garment technologist<span>:</span>{" "}
                  </li>
                  <li>
                    {" "}
                    {styleInfo.garmentType === null
                      ? null
                      : styleInfo.garmentType.name}{" "}
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Range<span>:</span>{" "}
                  </li>
                  {/* <li>{styleInfo.reference.range}</li> */}
                </ul>
              </li>
              <li>
                <ul>
                  <li>
                    Set<span>:</span>{" "}
                  </li>
                  <li>{styleInfo.setType ? "YES" : "NO"}</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-12 view-ib-bottom">
          <div class="col-md-2 step-one">
            <div class="form-group">
              <label for="item">Style Orgination</label>
              <span>
                <h6>{styleInfo.styleOrigination.name}</h6>
              </span>
              {/* <input type="text" class="form-control" placeholder="" value="" />  */}
            </div>
          </div>
          <div class="col-md-2 step-one">
            <div class="form-group">
              <label for="item">Block Reference</label>
              <span>
                <h6>{styleInfo.blockRefNumber}</h6>
              </span>
              {/* <input type="text" class="form-control" placeholder="" value="" /> */}
            </div>
          </div>
          <div class="col-md-3 step-one">
            <div class="form-group">
              <label for="item">Sketch from</label>
              <input
                type="text"
                class="form-control"
                readOnly
                placeholder=""
                value=""
              />
            </div>
          </div>
          <div class="col-md-5 step-one">
            <div class="form-group">
              <label for="item">Action by</label>
              <input
                type="text"
                class="form-control"
                placeholder=""
                readOnly
                // value={styleInfo.reference.actionedBy}
              />
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="fabric-textarea">
            <label for="item">Aditional Style Information</label>
            <textarea
              type="text"
              class="form-control"
              rows="3"
              id=""
              onChange={e => onChange(e.target.value)}
            ></textarea>
          </div>
        </div>
        <div class="col-md-12 profile-btn text-center">
          <button class="primary" name="button">
            Save to Continue
          </button>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/CreateIBComponents/StyleInfo/StyleInfo.js